import { cn } from "~/lib/utils";
import { ForgeWordmark } from "./ForgeWordmark";

interface AppTopBarLogoProps {
  readonly className?: string;
}

export function AppTopBarLogo({ className }: AppTopBarLogoProps) {
  return (
    <div className={cn("pointer-events-none flex select-none items-center", className)}>
      <ForgeWordmark />
    </div>
  );
}
